

export class SOPostHello {

  constructor(
    public loginStyle: number,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostHello(
      'loginStyle' in params ? params.loginStyle : null,
    );
  }
}
